import { Pipe, PipeTransform } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";
import { INTERVAL_DAILY, INTERVAL_WEEKLY } from "../entities/constants";

@Pipe({
	name: "stake_reward_interval",
	standalone: false
})
export class StakingRewardIntervalPipe implements PipeTransform {
	public constructor(private translationService: TranslationService) {}

	transform(interval: number): string {
		if (interval === INTERVAL_DAILY || interval === INTERVAL_WEEKLY) {
			return this.translationService.translate(interval === INTERVAL_DAILY ? "daily" : "weekly");
		}
		return this.translationService.translate("staking_reward_interval", [interval]);
	}
}
